const messages = require('./id-ID/messages.json');

export default messages;
